<template>
  <div v-if="isOpen" class="modal fade show" aria-labelledby="addNewCardTitle"
       style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">{{ props.form?.project_account_name }}</h1>
              <div class="d-flex align-items-center gap-2">
                <span v-if="props.form.unit_name" class="badge bg-info fs-6">
                  {{ props.form.unit_name }}
                </span>
                <button
                    @click="toggleModal"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-0">

        <!-- Nav Tabs -->
        <ul v-if="isTask && form.id" class="nav nav-tabs px-2" role="tablist">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'period' }" @click="activeTab = 'period'" href="javascript:void(0)">
              Period Breakdown
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'team' }" @click="activeTab = 'team'" href="javascript:void(0)">
              Team Member Breakdown
            </a>
          </li>
        </ul>

        <div class="pb-2 pt-1">
          <!-- form -->
          <form @submit.prevent="handleSubmit">
            <fieldset :disabled="props.readonly">
            <div class="row gy-2 px-2">
              <div v-if="isTask" class="col-3">
                <label class="form-label" for="item">Qty/Hour</label>
                <div>
                  <input
                      type="text"
                      class="form-control"
                      v-model="props.form.quantity"
                  >
                </div>
              </div>
              <div v-if="isTask" class="col-3"></div>
              <div v-else class="col-3">
                <label class="form-label" for="quantity">Qty</label>
                <div>
                  <input
                      type="text"
                      name="quantity"
                      class="form-control"
                      v-model="props.form.quantity"
                      @keyup="calculateAmount"
                      @input="fillFromTotals"
                  >
                </div>
              </div>
              <div v-if="isTask" class="col-3"></div>
              <div v-else class="col-3">
                <label class="form-label" for="rate">Rate</label>
                <div>
                  <input
                      type="text"
                      name="rate"
                      class="form-control"
                      v-model="props.form.rate"
                      @keyup="calculateAmount"
                      @input="fillFromTotals"
                  >
                </div>
              </div>
              <div v-if="!isTask" class="col-3">
                <label class="form-label" for="item">Amount</label>
                <div>
                  <input
                      type="text"
                      class="form-control"
                      v-model="props.form.amount"
                      @keyup="clearRate"
                      :disabled="isAutoFilled"
                  >
                </div>
              </div>
              <div class="col-3">
                <span v-if="isFillVisible && activeTab === 'period' && ! isAutoFilled && ! props.readonly">
                  <button class="btn btn-sm btn-info mt-2" type="button" @click="computeFill">
                    Fill
                  </button>
                </span>
                &nbsp;
                <span v-if="isAttributeVisible && ! props.readonly">
                  <button class="btn btn-sm btn-info mt-2" type="button" @click="computeAttribute">
                    Attribute
                  </button>
               </span>
              </div>
              <div v-if="isAutoFilled && ! props.readonly" class="col-12">
                <p class="text-muted small mb-0">Type Qty and Rate. Amount and the period breakdown fill themselves. You can still change any period.</p>
              </div>

              <!-- Period Breakdown Table -->
              <div v-if="activeTab === 'period'" class="col-12">
                <div v-if="isTask" class="col-10 m-auto mt-2">
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Period Breakdown</th>
                          <th class="text-end w-150">Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(breakdown, key) in props.form.breakdown" :key="key">
                          <td class="fw-bold">{{ key }}</td>
                          <td>
                            <input
                              type="text"
                              class="form-control form-control-sm text-end"
                              v-model="props.form.breakdown_qty[key]"
                              @input="sumQuantity"
                              placeholder="Qty"
                            >
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="table-secondary fw-bold">
                          <td>TOTAL</td>
                          <td class="text-end px-1">{{ totalQty }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div v-else class="table-responsive mt-2">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>Period Breakdown</th>
                        <th class="text-end w-150">Qty</th>
                        <th class="text-end w-150">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(breakdown, key) in props.form.breakdown" :key="key">
                        <td class="fw-bold">{{ key }}</td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm text-end"
                            v-model="props.form.breakdown_qty[key]"
                            @input="sumQuantity"
                            placeholder="Qty"
                          >
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm text-end"
                            v-model="props.form.breakdown[key]"
                            @input="sumAmount"
                            placeholder="Amount"
                          >
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-secondary fw-bold">
                        <td>TOTAL</td>
                        <td class="text-end px-1">{{ totalQty }}</td>
                        <td class="text-end px-1">{{ totalAmount }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <!-- Team Member Breakdown Table -->
              <div v-if="activeTab === 'team'" class="col-12 mt-2">
                <div class="table-responsive">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>Team Member</th>
                        <th>Role</th>
                        <th class="text-end w-150">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="team in props.form.project_teams" :key="team.id">
                        <td class="fw-bold">{{ team.team_member_name }}</td>
                        <td>{{ team.team_role_label }}</td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm text-end"
                            v-model="props.form.team_member_breakdown_qty[team.team_member_id]"
                            @input="sumQuantity"
                            placeholder="Qty"
                          >
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-secondary fw-bold">
                        <td colspan="2">TOTAL</td>
                        <td class="text-end px-1">{{ totalQty }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            </fieldset>

            <div class="col-12 text-center">
              <hr class="mt-2">
              <button v-if="! props.readonly" :disabled="loading || props.saving" type="submit"
                      class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light">
                <div v-if="loading || props.saving" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
              <button v-if="! props.readonly" @click.prevent="resetBreakdown" class="btn btn-outline-secondary  me-1 mt-1 waves-effect waves-float waves-light">
                Reset Breakdown
              </button>
              <button @click.prevent="toggleModal" class="btn btn-outline-secondary mt-1 waves-effect">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, ref} from "vue";

const props = defineProps({
  form: Object,
  accountType: String,
  readonly: {
    type: Boolean,
    default: false
  },
  saving: {
    type: Boolean,
    default: false
  },
});
const emit = defineEmits(['onCloseModal', 'onBusinessGeneralSave', 'onResetBreakdown'])

let isOpen = ref(false);
let loading = ref(false);
let isAttributeVisible = ref(true);
let isFillVisible = ref(true);
let activeTab = ref('period');
const autoFilledTabs = ['item'];

const isTask = computed(() => {
  return ['task', 'donor_kpi'].includes(props.form.project_type);
});

const isAutoFilled = computed(() => {
  return autoFilledTabs.includes(props.accountType);
});

const sumValues = (values) => {
  return Math.round(Object.values(values || {}).reduce((sum, value) => sum + Number(value || 0), 0));
}

const totalQty = computed(() => {
  if (activeTab.value === 'period') return sumValues(props.form.breakdown_qty);

  return sumValues(props.form.team_member_breakdown_qty);
});

const totalAmount = computed(() => {
  if (activeTab.value === 'period') return sumValues(props.form.breakdown);

  return sumValues(props.form.team_member_breakdown);
});

const openModal = () => {
  if (!props.form.team_member_breakdown) props.form.team_member_breakdown = {};
  if (!props.form.team_member_breakdown_qty) props.form.team_member_breakdown_qty = {};
  isOpen.value = true;
}

const closeModal = () => {
  isOpen.value = false;
  emit("onCloseModal");
}

const toggleModal = () => {
  if (isOpen.value) {
    closeModal();
    return;
  }
  
  openModal();
}
const setActiveTab = (tab) => {
  activeTab.value = tab;
}
defineExpose({toggleModal, openModal, closeModal, setActiveTab, activeTab});

const handleSubmit = () => {
  if (props.readonly || props.saving) return
  emit('onBusinessGeneralSave', props.form.id);
}

const calculateAmount = () => {
  if (isAutoFilled.value) return;

  hideFill();
  props.form.amount = props.form.rate * props.form.quantity;
}

const fillFromTotals = () => {
  if (! isAutoFilled.value) return;

  props.form.amount = props.form.rate * props.form.quantity;

  if (Number.isNaN(props.form.amount) || ! props.form.breakdown) return;

  computeAttribute();
}

const clearRate = () => {
  hideFill();
  props.form.rate = 0;
  props.form.quantity = 0;
}

const sumAmount = () => {
  hideAttribute();
  props.form.amount = totalAmount.value;
}

const sumQuantity = () => {
  props.form.quantity = totalQty.value;
};

const hideFill = () => {
  isAttributeVisible.value = true;
  isFillVisible.value = props.form.amount <= 0;
}

const hideAttribute = (value) => {
  isFillVisible.value = true;
  isAttributeVisible.value = value <= 0;
}

const computeFill = () => {
  props.form.fill_type = 'fill';

  const value = Object.values(props.form.breakdown)[0] || 0;

  Object.keys(props.form.breakdown).map(key => {
    props.form.breakdown[key] = value;
  });

  props.form.amount = totalAmount.value;
  props.form.rate = 0;
  props.form.quantity = 0;
}

const computeAttribute = () => {
  if (activeTab.value !== 'period') {
    // Team Breakdown Attribute
    const teams = props.form.project_teams || [];
    if (teams.length < 1) return;

    const valAmt = (props.form.amount / teams.length).toFixed(2);
    const valQty = (props.form.quantity / teams.length).toFixed(2);
    
    teams.forEach(t => {
      props.form.team_member_breakdown[t.team_member_id] = valAmt;
      props.form.team_member_breakdown_qty[t.team_member_id] = valQty;
    });
    return;
  }

  // Period Logic
  if (!isTask.value) {
    props.form.fill_type = 'attribute';
    const breakdownKeys = Object.keys(props.form.breakdown);
    const value = (props.form.amount / breakdownKeys.length).toFixed(2);

    breakdownKeys.forEach(key => {
      props.form.breakdown[key] = value;
    });
  }

  const keysQty = Object.keys(props.form.breakdown_qty);
  if (!keysQty.length) return;

  const valueQty = (props.form.quantity / keysQty.length).toFixed(2);
  keysQty.forEach(key => {
    props.form.breakdown_qty[key] = valueQty;
  });
}

const resetBreakdown = () => {
  if (activeTab.value === 'team') {
    Object.keys(props.form.team_member_breakdown || {}).forEach(key => {
      props.form.team_member_breakdown[key] = 0;
    });
    Object.keys(props.form.team_member_breakdown_qty || {}).forEach(key => {
      props.form.team_member_breakdown_qty[key] = 0;
    });
    return;
  }
  emit('onResetBreakdown', props.form.budget_master_id)
}
</script>

<style scoped>
.w-150 {
  width: 150px;
}
</style>